import script from "./FAQPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./FAQPage.vue?vue&type=script&lang=ts&setup=true"

import "./FAQPage.vue?vue&type=style&index=0&id=5f7bd16e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f7bd16e"]])

export default __exports__